<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb -->
    <div class="mb-3 row">
      <div class="col-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/tramite">Trámites</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm', params: { p_idtramite } }">
                Trámite N.° {{ p_idtramite }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm',
                                  params: { p_idtramite },
                                  query: { tab: 'reportes' } }">
                Reportes
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Productividad — Trámite N.° {{ p_idtramite }}
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <!-- Info trámite -->
    <div class="card border-0 mb-3" style="background-color: #e8f4fd;">
      <div class="card-body py-2 px-3">
        <span class="text-dark fw-bold">{{ datosTramite }}</span>
      </div>
    </div>

    <!-- Cargando -->
    <div v-if="cargando" class="alert alert-info py-2 px-3" role="alert">
      Cargando datos...
    </div>

    <div v-else>
      <!-- Tarjetas resumen -->
      <div class="row g-3 mb-4">
        <div class="col-auto">
          <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 150px;">
            <div class="small text-muted fw-bold">Auditoría médica</div>
            <div class="fs-4 fw-bold text-primary">{{ auditorias.length }}</div>
          </div>
        </div>
        <div class="col-auto">
          <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 150px;">
            <div class="small text-muted fw-bold">Gestión documental</div>
            <div class="fs-4 fw-bold text-primary">{{ documentales.length }}</div>
          </div>
        </div>
        <div class="col-auto">
          <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 150px;">
            <div class="small text-muted fw-bold">Detalles</div>
            <div class="fs-4 fw-bold text-primary">{{ detalles.length }}</div>
          </div>
        </div>
        <div class="col-auto">
          <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 150px;">
            <div class="small text-muted fw-bold">Usuarios (aud.)</div>
            <div class="fs-4 fw-bold text-success">{{ resumenAud.length }}</div>
          </div>
        </div>
        <div class="col-auto">
          <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 150px;">
            <div class="small text-muted fw-bold">Usuarios (doc.)</div>
            <div class="fs-4 fw-bold text-success">{{ resumenDoc.length }}</div>
          </div>
        </div>
        <div class="col-auto">
          <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 150px;">
            <div class="small text-muted fw-bold">Usuarios (detalle)</div>
            <div class="fs-4 fw-bold text-success">{{ resumenDet.length }}</div>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'auditoria' }"
            href="#" @click.prevent="activeTab = 'auditoria'">
            <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">medical_services</span>
            Auditoría Médica
            <span class="badge bg-primary ms-1">{{ auditoriasFiltradas.length }}</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'documental' }"
            href="#" @click.prevent="activeTab = 'documental'">
            <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">folder_open</span>
            Gestión Documental
            <span class="badge bg-primary ms-1">{{ documentalesFiltradas.length }}</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'detalle' }"
            href="#" @click.prevent="activeTab = 'detalle'">
            <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">list</span>
            Detalle
            <span class="badge bg-primary ms-1">{{ detallesFiltrados.length }}</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'resumenAud' }"
            href="#" @click.prevent="activeTab = 'resumenAud'">
            <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">bar_chart</span>
            Resumen Auditoría
            <span class="badge bg-success ms-1">{{ resumenAud.length }}</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'resumenDoc' }"
            href="#" @click.prevent="activeTab = 'resumenDoc'">
            <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">bar_chart</span>
            Resumen Documental
            <span class="badge bg-success ms-1">{{ resumenDoc.length }}</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'resumenDet' }"
            href="#" @click.prevent="activeTab = 'resumenDet'">
            <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">bar_chart</span>
            Resumen Detalle
            <span class="badge bg-success ms-1">{{ resumenDet.length }}</span>
          </a>
        </li>
      </ul>

      <!-- ══════════════════════════════════════════════════ -->
      <!-- Tab: Auditoría Médica (/aud)                       -->
      <!-- ══════════════════════════════════════════════════ -->
      <div v-if="activeTab === 'auditoria'">
        <div v-if="auditoriasFiltradas.length === 0" class="alert alert-warning">
          No se encontraron registros de auditoría médica.
        </div>
        <div v-else>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="d-flex align-items-center gap-2">
              <label class="form-label mb-0 small fw-bold">Mostrar</label>
              <select v-model.number="itemsPerPageAud" class="form-select form-select-sm"
                style="width: 75px" @change="paginaAud = 1">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
              <span class="small text-muted">registros</span>
              <button class="btn btn-success btn-sm d-flex align-items-center gap-1"
                @click="exportarExcelAuditoria" :disabled="auditoriasFiltradas.length === 0">
                <span class="material-icons" style="font-size:16px">table_view</span> Excel
              </button>
            </div>
            <input v-model="filtroAud" class="form-control form-control-sm" style="width: 220px"
              placeholder="🔍 Buscar..." @input="paginaAud = 1" />
          </div>
          <div class="table-responsive">
            <table class="table table-hover table-bordered table-sm">
              <thead class="table-dark">
                <tr>
                  <th class="th-sort" @click="ordenarAud('numero')">N.° <span>{{ iconAud('numero') }}</span></th>
                  <th class="th-sort" @click="ordenarAud('nombre')">Nombre <span>{{ iconAud('nombre') }}</span></th>
                  <th class="th-sort" @click="ordenarAud('usuario')">Usuario <span>{{ iconAud('usuario') }}</span></th>
                  <th class="th-sort" @click="ordenarAud('fechaAud')">Fecha Aud. <span>{{ iconAud('fechaAud') }}</span></th>
                </tr>
                <tr>
                  <th><input v-model="filtrosAud.numero"   @input="paginaAud = 1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th><input v-model="filtrosAud.nombre"   @input="paginaAud = 1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th><input v-model="filtrosAud.usuario"  @input="paginaAud = 1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th><input v-model="filtrosAud.fechaAud" @input="paginaAud = 1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in pagedAud" :key="r.idTramite + '-aud-' + r.numero">
                  <td>{{ r.numero }}</td>
                  <td>{{ r.nombre }}</td>
                  <td>{{ r.usuario }}</td>
                  <td>{{ formatFecha(r.fechaAud) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-secondary">
                  <td colspan="4" class="text-end fw-bold small">
                    Mostrando {{ pagedAud.length }} de {{ auditoriasFiltradas.length }} registros
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="d-flex justify-content-between align-items-center mt-2">
            <span class="small text-muted">Página {{ paginaAud }} de {{ totalPagesAud }} — {{ auditoriasFiltradas.length }} registros</span>
            <nav>
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" :class="{ disabled: paginaAud === 1 }">
                  <a class="page-link" href="#" @click.prevent="paginaAud = 1">«</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaAud === 1 }">
                  <a class="page-link" href="#" @click.prevent="paginaAud--">‹</a>
                </li>
                <li v-for="p in paginasVisibles(paginaAud, totalPagesAud)" :key="p"
                  class="page-item" :class="{ active: p === paginaAud, disabled: p === '...' }">
                  <a class="page-link" href="#" @click.prevent="p !== '...' && (paginaAud = p)">{{ p }}</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaAud === totalPagesAud }">
                  <a class="page-link" href="#" @click.prevent="paginaAud++">›</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaAud === totalPagesAud }">
                  <a class="page-link" href="#" @click.prevent="paginaAud = totalPagesAud">»</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      <!-- ══════════════════════════════════════════════════ -->
      <!-- Tab: Gestión Documental (/doc)                     -->
      <!-- ══════════════════════════════════════════════════ -->
      <div v-if="activeTab === 'documental'">
        <div v-if="documentalesFiltradas.length === 0" class="alert alert-warning">
          No se encontraron registros de gestión documental.
        </div>
        <div v-else>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="d-flex align-items-center gap-2">
              <label class="form-label mb-0 small fw-bold">Mostrar</label>
              <select v-model.number="itemsPerPageDoc" class="form-select form-select-sm"
                style="width: 75px" @change="paginaDoc = 1">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
              <span class="small text-muted">registros</span>
              <button class="btn btn-success btn-sm d-flex align-items-center gap-1"
                @click="exportarExcelDocumental" :disabled="documentalesFiltradas.length === 0">
                <span class="material-icons" style="font-size:16px">table_view</span> Excel
              </button>
            </div>
            <input v-model="filtroDoc" class="form-control form-control-sm" style="width: 220px"
              placeholder="🔍 Buscar..." @input="paginaDoc = 1" />
          </div>
          <div class="table-responsive">
            <table class="table table-hover table-bordered table-sm">
              <thead class="table-dark">
                <tr>
                  <th class="th-sort" @click="ordenarDoc('numero')">N.° <span>{{ iconDoc('numero') }}</span></th>
                  <th class="th-sort" @click="ordenarDoc('nombre')">Nombre <span>{{ iconDoc('nombre') }}</span></th>
                  <th class="th-sort" @click="ordenarDoc('usuario')">Usuario <span>{{ iconDoc('usuario') }}</span></th>
                  <th class="th-sort" @click="ordenarDoc('fechaDoc')">Fecha Doc. <span>{{ iconDoc('fechaDoc') }}</span></th>
                </tr>
                <tr>
                  <th><input v-model="filtrosDoc.numero"   @input="paginaDoc = 1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th><input v-model="filtrosDoc.nombre"   @input="paginaDoc = 1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th><input v-model="filtrosDoc.usuario"  @input="paginaDoc = 1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th><input v-model="filtrosDoc.fechaDoc" @input="paginaDoc = 1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in pagedDoc" :key="r.idTramite + '-doc-' + r.numero">
                  <td>{{ r.numero }}</td>
                  <td>{{ r.nombre }}</td>
                  <td>{{ r.usuario }}</td>
                  <td>{{ formatFecha(r.fechaDoc) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-secondary">
                  <td colspan="4" class="text-end fw-bold small">
                    Mostrando {{ pagedDoc.length }} de {{ documentalesFiltradas.length }} registros
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="d-flex justify-content-between align-items-center mt-2">
            <span class="small text-muted">Página {{ paginaDoc }} de {{ totalPagesDoc }} — {{ documentalesFiltradas.length }} registros</span>
            <nav>
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" :class="{ disabled: paginaDoc === 1 }">
                  <a class="page-link" href="#" @click.prevent="paginaDoc = 1">«</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaDoc === 1 }">
                  <a class="page-link" href="#" @click.prevent="paginaDoc--">‹</a>
                </li>
                <li v-for="p in paginasVisibles(paginaDoc, totalPagesDoc)" :key="p"
                  class="page-item" :class="{ active: p === paginaDoc, disabled: p === '...' }">
                  <a class="page-link" href="#" @click.prevent="p !== '...' && (paginaDoc = p)">{{ p }}</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaDoc === totalPagesDoc }">
                  <a class="page-link" href="#" @click.prevent="paginaDoc++">›</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaDoc === totalPagesDoc }">
                  <a class="page-link" href="#" @click.prevent="paginaDoc = totalPagesDoc">»</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      <!-- ══════════════════════════════════════════════════ -->
      <!-- Tab: Detalle (/detalle)                            -->
      <!-- ══════════════════════════════════════════════════ -->
      <div v-if="activeTab === 'detalle'">
        <div v-if="detallesFiltrados.length === 0" class="alert alert-warning">
          No se encontraron detalles de productividad.
        </div>
        <div v-else>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="d-flex align-items-center gap-2">
              <label class="form-label mb-0 small fw-bold">Mostrar</label>
              <select v-model.number="itemsPerPageDet" class="form-select form-select-sm"
                style="width: 75px" @change="paginaDet = 1">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
              <span class="small text-muted">registros</span>
              <button class="btn btn-success btn-sm d-flex align-items-center gap-1"
                @click="exportarExcelDetalles" :disabled="detallesFiltrados.length === 0">
                <span class="material-icons" style="font-size:16px">table_view</span> Excel
              </button>
            </div>
            <input v-model="filtroDet" class="form-control form-control-sm" style="width: 220px"
              placeholder="🔍 Buscar..." @input="paginaDet = 1" />
          </div>
          <div class="table-responsive">
            <table class="table table-hover table-bordered table-sm">
              <thead class="table-dark">
                <tr>
                  <th class="th-sort" @click="ordenarDet('numero')">N.° <span>{{ iconDet('numero') }}</span></th>
                  <th class="th-sort" @click="ordenarDet('nombre')">Nombre <span>{{ iconDet('nombre') }}</span></th>
                  <th class="th-sort" @click="ordenarDet('codigo')">Código <span>{{ iconDet('codigo') }}</span></th>
                  <th class="th-sort" @click="ordenarDet('descripcion')">Descripción <span>{{ iconDet('descripcion') }}</span></th>
                  <th class="th-sort" @click="ordenarDet('usuario')">Usuario <span>{{ iconDet('usuario') }}</span></th>
                  <th class="th-sort" @click="ordenarDet('fechaAct')">Fecha Act. <span>{{ iconDet('fechaAct') }}</span></th>
                </tr>
                <tr>
                  <th><input v-model="filtrosDet.numero"      @input="paginaDet = 1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th><input v-model="filtrosDet.nombre"      @input="paginaDet = 1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th><input v-model="filtrosDet.codigo"      @input="paginaDet = 1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th><input v-model="filtrosDet.descripcion" @input="paginaDet = 1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th><input v-model="filtrosDet.usuario"     @input="paginaDet = 1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th><input v-model="filtrosDet.fechaAct"    @input="paginaDet = 1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in pagedDet" :key="r.idTramite + '-det-' + r.codigo + '-' + r.numero">
                  <td>{{ r.numero }}</td>
                  <td>{{ r.nombre }}</td>
                  <td><code>{{ r.codigo }}</code></td>
                  <td>{{ r.descripcion }}</td>
                  <td>{{ r.usuario }}</td>
                  <td>{{ formatFecha(r.fechaAct) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-secondary">
                  <td colspan="6" class="text-end fw-bold small">
                    Mostrando {{ pagedDet.length }} de {{ detallesFiltrados.length }} registros
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="d-flex justify-content-between align-items-center mt-2">
            <span class="small text-muted">Página {{ paginaDet }} de {{ totalPagesDet }} — {{ detallesFiltrados.length }} registros</span>
            <nav>
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" :class="{ disabled: paginaDet === 1 }">
                  <a class="page-link" href="#" @click.prevent="paginaDet = 1">«</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaDet === 1 }">
                  <a class="page-link" href="#" @click.prevent="paginaDet--">‹</a>
                </li>
                <li v-for="p in paginasVisibles(paginaDet, totalPagesDet)" :key="p"
                  class="page-item" :class="{ active: p === paginaDet, disabled: p === '...' }">
                  <a class="page-link" href="#" @click.prevent="p !== '...' && (paginaDet = p)">{{ p }}</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaDet === totalPagesDet }">
                  <a class="page-link" href="#" @click.prevent="paginaDet++">›</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaDet === totalPagesDet }">
                  <a class="page-link" href="#" @click.prevent="paginaDet = totalPagesDet">»</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
<br>
      <!-- ══════════════════════════════════════════════════ -->
      <!-- Tab: Resumen Auditoría                             -->
      <!-- ══════════════════════════════════════════════════ -->
      <div v-if="activeTab === 'resumenAud'">
        <div v-if="resumenAud.length === 0" class="alert alert-warning">
          No hay datos para resumir.
        </div>
        <div v-else class="row g-4">
          <div class="col-12 col-lg-5">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-header bg-primary text-white py-2 px-3 small fw-bold">
                <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">table</span>
                Auditoría por usuario
              </div>
              <div class="card-body p-0">
                <table class="table table-hover table-sm mb-0">
                  <thead class="table-dark">
                    <tr>
                      <th class="th-sort px-3" @click="ordenarResumenAud('usuario')">
                        Usuario <span>{{ iconResumenAud('usuario') }}</span>
                      </th>
                      <th class="th-sort text-end px-3" @click="ordenarResumenAud('total')">
                        Total <span>{{ iconResumenAud('total') }}</span>
                      </th>
                      <th class="px-3">% del total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="r in resumenAudOrdenado" :key="r.usuario">
                      <td class="px-3">{{ r.usuario }}</td>
                      <td class="text-end px-3 fw-bold text-primary">{{ r.total }}</td>
                      <td class="px-3">
                        <div class="d-flex align-items-center gap-2">
                          <div class="progress flex-grow-1" style="height: 8px;">
                            <div class="progress-bar bg-primary"
                              :style="{ width: porcentajeAud(r.total) + '%' }"></div>
                          </div>
                          <span class="small text-muted" style="min-width:38px">
                            {{ porcentajeAud(r.total) }}%
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="table-secondary fw-bold">
                      <td class="px-3">Total</td>
                      <td class="text-end px-3 text-primary">{{ auditorias.length }}</td>
                      <td class="px-3">100%</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-7">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-header bg-primary text-white py-2 px-3 small fw-bold">
                <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">bar_chart</span>
                Distribución por usuario
              </div>
              <div class="card-body">
                <div v-for="r in resumenAudOrdenado" :key="r.usuario" class="mb-3">
                  <div class="d-flex justify-content-between small mb-1">
                    <span class="fw-bold text-truncate" style="max-width: 60%">{{ r.usuario }}</span>
                    <span class="text-muted">{{ r.total }} registros</span>
                  </div>
                  <div class="progress" style="height: 22px; border-radius: 4px;">
                    <div class="progress-bar bg-primary progress-bar-striped"
                      role="progressbar"
                      :style="{ width: porcentajeAud(r.total) + '%', minWidth: '28px' }">
                      <span class="small fw-bold">{{ porcentajeAud(r.total) }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ══════════════════════════════════════════════════ -->
      <!-- Tab: Resumen Documental                            -->
      <!-- ══════════════════════════════════════════════════ -->
      <div v-if="activeTab === 'resumenDoc'">
        <div v-if="resumenDoc.length === 0" class="alert alert-warning">
          No hay datos para resumir.
        </div>
        <div v-else class="row g-4">
          <div class="col-12 col-lg-5">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-header bg-info text-white py-2 px-3 small fw-bold">
                <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">table</span>
                Documental por usuario
              </div>
              <div class="card-body p-0">
                <table class="table table-hover table-sm mb-0">
                  <thead class="table-dark">
                    <tr>
                      <th class="th-sort px-3" @click="ordenarResumenDoc('usuario')">
                        Usuario <span>{{ iconResumenDoc('usuario') }}</span>
                      </th>
                      <th class="th-sort text-end px-3" @click="ordenarResumenDoc('total')">
                        Total <span>{{ iconResumenDoc('total') }}</span>
                      </th>
                      <th class="px-3">% del total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="r in resumenDocOrdenado" :key="r.usuario">
                      <td class="px-3">{{ r.usuario }}</td>
                      <td class="text-end px-3 fw-bold text-info">{{ r.total }}</td>
                      <td class="px-3">
                        <div class="d-flex align-items-center gap-2">
                          <div class="progress flex-grow-1" style="height: 8px;">
                            <div class="progress-bar bg-info"
                              :style="{ width: porcentajeDoc(r.total) + '%' }"></div>
                          </div>
                          <span class="small text-muted" style="min-width:38px">
                            {{ porcentajeDoc(r.total) }}%
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="table-secondary fw-bold">
                      <td class="px-3">Total</td>
                      <td class="text-end px-3 text-info">{{ documentales.length }}</td>
                      <td class="px-3">100%</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-7">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-header bg-info text-white py-2 px-3 small fw-bold">
                <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">bar_chart</span>
                Distribución por usuario
              </div>
              <div class="card-body">
                <div v-for="r in resumenDocOrdenado" :key="r.usuario" class="mb-3">
                  <div class="d-flex justify-content-between small mb-1">
                    <span class="fw-bold text-truncate" style="max-width: 60%">{{ r.usuario }}</span>
                    <span class="text-muted">{{ r.total }} registros</span>
                  </div>
                  <div class="progress" style="height: 22px; border-radius: 4px;">
                    <div class="progress-bar bg-info progress-bar-striped"
                      role="progressbar"
                      :style="{ width: porcentajeDoc(r.total) + '%', minWidth: '28px' }">
                      <span class="small fw-bold">{{ porcentajeDoc(r.total) }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ══════════════════════════════════════════════════ -->
      <!-- Tab: Resumen Detalle                               -->
      <!-- ══════════════════════════════════════════════════ -->
      <div v-if="activeTab === 'resumenDet'">
        <div v-if="resumenDet.length === 0" class="alert alert-warning">
          No hay datos para resumir.
        </div>
        <div v-else class="row g-4">
          <div class="col-12 col-lg-5">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-header bg-success text-white py-2 px-3 small fw-bold">
                <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">table</span>
                Detalles por usuario
              </div>
              <div class="card-body p-0">
                <table class="table table-hover table-sm mb-0">
                  <thead class="table-dark">
                    <tr>
                      <th class="th-sort px-3" @click="ordenarResumenDet('usuario')">
                        Usuario <span>{{ iconResumenDet('usuario') }}</span>
                      </th>
                      <th class="th-sort text-end px-3" @click="ordenarResumenDet('total')">
                        Total <span>{{ iconResumenDet('total') }}</span>
                      </th>
                      <th class="px-3">% del total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="r in resumenDetOrdenado" :key="r.usuario">
                      <td class="px-3">{{ r.usuario }}</td>
                      <td class="text-end px-3 fw-bold text-success">{{ r.total }}</td>
                      <td class="px-3">
                        <div class="d-flex align-items-center gap-2">
                          <div class="progress flex-grow-1" style="height: 8px;">
                            <div class="progress-bar bg-success"
                              :style="{ width: porcentajeDet(r.total) + '%' }"></div>
                          </div>
                          <span class="small text-muted" style="min-width:38px">
                            {{ porcentajeDet(r.total) }}%
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="table-secondary fw-bold">
                      <td class="px-3">Total</td>
                      <td class="text-end px-3 text-success">{{ detalles.length }}</td>
                      <td class="px-3">100%</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-7">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-header bg-success text-white py-2 px-3 small fw-bold">
                <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">bar_chart</span>
                Distribución por usuario
              </div>
              <div class="card-body">
                <div v-for="r in resumenDetOrdenado" :key="r.usuario" class="mb-3">
                  <div class="d-flex justify-content-between small mb-1">
                    <span class="fw-bold text-truncate" style="max-width: 60%">{{ r.usuario }}</span>
                    <span class="text-muted">{{ r.total }} detalles</span>
                  </div>
                  <div class="progress" style="height: 22px; border-radius: 4px;">
                    <div class="progress-bar bg-success progress-bar-striped"
                      role="progressbar"
                      :style="{ width: porcentajeDet(r.total) + '%', minWidth: '28px' }">
                      <span class="small fw-bold">{{ porcentajeDet(r.total) }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api    from "@/services/api";
import * as XLSX from "xlsx";

export default {
  name: "ProductividadReporte",
  components: { Layout, Footer },
  props: {
    p_idtramite:     { type: Number, required: true },
    p_idservicio:    { type: Number, required: true },
    p_estadoTramite: { type: String, required: true },
  },
  data() {
    return {
      cargando:     false,
      activeTab:    "auditoria",
      datosTramite: "",

      // Datos crudos — tres fuentes
      auditorias:   [],   // GET /aud   → ProductividadAudDTO  (fechaAud)
      documentales: [],   // GET /doc   → ProductividadDocDTO  (fechaDoc)
      detalles:     [],   // GET /detalle → ProductividadDetDTO (fechaAct)

      // ── Paginación auditoría ─────────────────────────────
      paginaAud:       1,
      itemsPerPageAud: 10,
      filtroAud:       "",
      filtrosAud: { numero: "", nombre: "", usuario: "", fechaAud: "" },
      campoAud:        "numero",
      ascAud:          true,

      // ── Paginación documental ────────────────────────────
      paginaDoc:       1,
      itemsPerPageDoc: 10,
      filtroDoc:       "",
      filtrosDoc: { numero: "", nombre: "", usuario: "", fechaDoc: "" },
      campoDoc:        "numero",
      ascDoc:          true,

      // ── Paginación detalle ───────────────────────────────
      paginaDet:       1,
      itemsPerPageDet: 10,
      filtroDet:       "",
      filtrosDet: { numero: "", nombre: "", codigo: "", descripcion: "", usuario: "", fechaAct: "" },
      campoDet:        "numero",
      ascDet:          true,

      // ── Ordenamiento resúmenes ───────────────────────────
      campoResumenAud: "total", ascResumenAud: false,
      campoResumenDoc: "total", ascResumenDoc: false,
      campoResumenDet: "total", ascResumenDet: false,
    };
  },
  computed: {
    // ── Auditoría ────────────────────────────────────────
    auditoriasFiltradas() {
      const f = this.filtrosAud;
      const q = this.filtroAud.toLowerCase();
      const lista = this.auditorias.filter(r => {
        const global = !q || [r.numero, r.nombre, r.usuario, r.fechaAud]
          .some(v => String(v ?? "").toLowerCase().includes(q));
        const col =
          (!f.numero   || String(r.numero   ?? "").toLowerCase().includes(f.numero.toLowerCase()))   &&
          (!f.nombre   || String(r.nombre   ?? "").toLowerCase().includes(f.nombre.toLowerCase()))   &&
          (!f.usuario  || String(r.usuario  ?? "").toLowerCase().includes(f.usuario.toLowerCase()))  &&
          (!f.fechaAud || String(r.fechaAud ?? "").toLowerCase().includes(f.fechaAud.toLowerCase()));
        return global && col;
      });
      return this._sort(lista, this.campoAud, this.ascAud);
    },
    totalPagesAud() {
      return Math.max(1, Math.ceil(this.auditoriasFiltradas.length / this.itemsPerPageAud));
    },
    pagedAud() {
      const s = (this.paginaAud - 1) * this.itemsPerPageAud;
      return this.auditoriasFiltradas.slice(s, s + this.itemsPerPageAud);
    },

    // ── Documental ───────────────────────────────────────
    documentalesFiltradas() {
      const f = this.filtrosDoc;
      const q = this.filtroDoc.toLowerCase();
      const lista = this.documentales.filter(r => {
        const global = !q || [r.numero, r.nombre, r.usuario, r.fechaDoc]
          .some(v => String(v ?? "").toLowerCase().includes(q));
        const col =
          (!f.numero   || String(r.numero   ?? "").toLowerCase().includes(f.numero.toLowerCase()))   &&
          (!f.nombre   || String(r.nombre   ?? "").toLowerCase().includes(f.nombre.toLowerCase()))   &&
          (!f.usuario  || String(r.usuario  ?? "").toLowerCase().includes(f.usuario.toLowerCase()))  &&
          (!f.fechaDoc || String(r.fechaDoc ?? "").toLowerCase().includes(f.fechaDoc.toLowerCase()));
        return global && col;
      });
      return this._sort(lista, this.campoDoc, this.ascDoc);
    },
    totalPagesDoc() {
      return Math.max(1, Math.ceil(this.documentalesFiltradas.length / this.itemsPerPageDoc));
    },
    pagedDoc() {
      const s = (this.paginaDoc - 1) * this.itemsPerPageDoc;
      return this.documentalesFiltradas.slice(s, s + this.itemsPerPageDoc);
    },

    // ── Detalle ──────────────────────────────────────────
    detallesFiltrados() {
      const f = this.filtrosDet;
      const q = this.filtroDet.toLowerCase();
      const lista = this.detalles.filter(r => {
        const global = !q || [r.numero, r.nombre, r.codigo, r.descripcion, r.usuario, r.fechaAct]
          .some(v => String(v ?? "").toLowerCase().includes(q));
        const col =
          (!f.numero      || String(r.numero      ?? "").toLowerCase().includes(f.numero.toLowerCase()))      &&
          (!f.nombre      || String(r.nombre      ?? "").toLowerCase().includes(f.nombre.toLowerCase()))      &&
          (!f.codigo      || String(r.codigo      ?? "").toLowerCase().includes(f.codigo.toLowerCase()))      &&
          (!f.descripcion || String(r.descripcion ?? "").toLowerCase().includes(f.descripcion.toLowerCase())) &&
          (!f.usuario     || String(r.usuario     ?? "").toLowerCase().includes(f.usuario.toLowerCase()))     &&
          (!f.fechaAct    || String(r.fechaAct    ?? "").toLowerCase().includes(f.fechaAct.toLowerCase()));
        return global && col;
      });
      return this._sort(lista, this.campoDet, this.ascDet);
    },
    totalPagesDet() {
      return Math.max(1, Math.ceil(this.detallesFiltrados.length / this.itemsPerPageDet));
    },
    pagedDet() {
      const s = (this.paginaDet - 1) * this.itemsPerPageDet;
      return this.detallesFiltrados.slice(s, s + this.itemsPerPageDet);
    },

    // ── Resúmenes agrupados por usuario ──────────────────
    resumenAud() {
      const mapa = {};
      this.auditorias.forEach(r => { const u = r.usuario || "(sin usuario)"; mapa[u] = (mapa[u] || 0) + 1; });
      return Object.entries(mapa).map(([usuario, total]) => ({ usuario, total }));
    },
    resumenAudOrdenado() {
      return this._sort([...this.resumenAud], this.campoResumenAud, this.ascResumenAud);
    },

    resumenDoc() {
      const mapa = {};
      this.documentales.forEach(r => { const u = r.usuario || "(sin usuario)"; mapa[u] = (mapa[u] || 0) + 1; });
      return Object.entries(mapa).map(([usuario, total]) => ({ usuario, total }));
    },
    resumenDocOrdenado() {
      return this._sort([...this.resumenDoc], this.campoResumenDoc, this.ascResumenDoc);
    },

    resumenDet() {
      const mapa = {};
      this.detalles.forEach(r => { const u = r.usuario || "(sin usuario)"; mapa[u] = (mapa[u] || 0) + 1; });
      return Object.entries(mapa).map(([usuario, total]) => ({ usuario, total }));
    },
    resumenDetOrdenado() {
      return this._sort([...this.resumenDet], this.campoResumenDet, this.ascResumenDet);
    },
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.cargarDatos();
    this.datosTramite = sessionStorage.getItem("datosTramite");
  },
  methods: {
    async cargarDatos() {
      this.cargando = true;
      try {
        const [resAud, resDoc, resDet] = await Promise.all([
          api.get(`/productividad/${this.p_idtramite}/aud`),
          api.get(`/productividad/${this.p_idtramite}/doc`),
          api.get(`/productividad/${this.p_idtramite}/detalle`),
        ]);
        // 204 No Content → data puede ser null/vacío
        this.auditorias   = Array.isArray(resAud.data)  ? resAud.data  : [];
        this.documentales = Array.isArray(resDoc.data)  ? resDoc.data  : [];
        this.detalles     = Array.isArray(resDet.data)  ? resDet.data  : [];
      } catch (e) {
        console.error("Error al cargar datos de productividad:", e);
        this.auditorias   = [];
        this.documentales = [];
        this.detalles     = [];
      } finally {
        this.cargando = false;
      }
    },

    // ── Ordenamiento auditoría ───────────────────────────
    ordenarAud(campo) { this.ascAud = this.campoAud === campo ? !this.ascAud : true; this.campoAud = campo; this.paginaAud = 1; },
    iconAud(campo)    { if (this.campoAud !== campo) return "⇅"; return this.ascAud ? "↑" : "↓"; },

    // ── Ordenamiento documental ──────────────────────────
    ordenarDoc(campo) { this.ascDoc = this.campoDoc === campo ? !this.ascDoc : true; this.campoDoc = campo; this.paginaDoc = 1; },
    iconDoc(campo)    { if (this.campoDoc !== campo) return "⇅"; return this.ascDoc ? "↑" : "↓"; },

    // ── Ordenamiento detalle ─────────────────────────────
    ordenarDet(campo) { this.ascDet = this.campoDet === campo ? !this.ascDet : true; this.campoDet = campo; this.paginaDet = 1; },
    iconDet(campo)    { if (this.campoDet !== campo) return "⇅"; return this.ascDet ? "↑" : "↓"; },

    // ── Ordenamiento resúmenes ───────────────────────────
    ordenarResumenAud(campo) { this.ascResumenAud = this.campoResumenAud === campo ? !this.ascResumenAud : campo !== "total"; this.campoResumenAud = campo; },
    iconResumenAud(campo)    { if (this.campoResumenAud !== campo) return "⇅"; return this.ascResumenAud ? "↑" : "↓"; },

    ordenarResumenDoc(campo) { this.ascResumenDoc = this.campoResumenDoc === campo ? !this.ascResumenDoc : campo !== "total"; this.campoResumenDoc = campo; },
    iconResumenDoc(campo)    { if (this.campoResumenDoc !== campo) return "⇅"; return this.ascResumenDoc ? "↑" : "↓"; },

    ordenarResumenDet(campo) { this.ascResumenDet = this.campoResumenDet === campo ? !this.ascResumenDet : campo !== "total"; this.campoResumenDet = campo; },
    iconResumenDet(campo)    { if (this.campoResumenDet !== campo) return "⇅"; return this.ascResumenDet ? "↑" : "↓"; },

    // ── Porcentajes ──────────────────────────────────────
    porcentajeAud(total) { return this.auditorias.length   ? Math.round((total / this.auditorias.length)   * 100) : 0; },
    porcentajeDoc(total) { return this.documentales.length ? Math.round((total / this.documentales.length) * 100) : 0; },
    porcentajeDet(total) { return this.detalles.length     ? Math.round((total / this.detalles.length)     * 100) : 0; },

    // ── Ordenamiento genérico ────────────────────────────
    _sort(lista, campo, asc) {
      return [...lista].sort((a, b) => {
        const va = a[campo] ?? ""; const vb = b[campo] ?? "";
        const na = parseFloat(va); const nb = parseFloat(vb);
        if (!isNaN(na) && !isNaN(nb)) return asc ? na - nb : nb - na;
        const cmp = String(va).localeCompare(String(vb), "es");
        return asc ? cmp : -cmp;
      });
    },

    // ── Paginación con puntos suspensivos ────────────────
    paginasVisibles(actual, total) {
      const delta = 2; const rango = [];
      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) rango.push(i);
      if (rango.length && rango[0] > 2)                        rango.unshift("...");
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push("...");
      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },

    // ── Formato fecha ────────────────────────────────────
    formatFecha(fecha) {
      if (!fecha) return "—";
      const d = new Date(fecha);
      if (isNaN(d)) return fecha;
      return d.toLocaleDateString("es-EC", {
        day: "2-digit", month: "2-digit", year: "numeric",
        hour: "2-digit", minute: "2-digit",
      });
    },

    // ── Exportar Excel auditoría ─────────────────────────
    exportarExcelAuditoria() {
      const headers = ["N.°", "Nombre", "Usuario", "Fecha Aud."];
      const filas = this.auditoriasFiltradas.map(r => [r.numero, r.nombre, r.usuario, this.formatFecha(r.fechaAud)]);
      const ws = XLSX.utils.aoa_to_sheet([headers, ...filas]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Auditoria");
      XLSX.writeFile(wb, `productividad_auditoria_tramite_${this.p_idtramite}.xlsx`);
    },

    // ── Exportar Excel documental ────────────────────────
    exportarExcelDocumental() {
      const headers = ["N.°", "Nombre", "Usuario", "Fecha Doc."];
      const filas = this.documentalesFiltradas.map(r => [r.numero, r.nombre, r.usuario, this.formatFecha(r.fechaDoc)]);
      const ws = XLSX.utils.aoa_to_sheet([headers, ...filas]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Documental");
      XLSX.writeFile(wb, `productividad_documental_tramite_${this.p_idtramite}.xlsx`);
    },

    // ── Exportar Excel detalles ──────────────────────────
    exportarExcelDetalles() {
      const headers = ["N.°", "Nombre", "Código", "Descripción", "Usuario", "Fecha Act."];
      const filas = this.detallesFiltrados.map(r => [r.numero, r.nombre, r.codigo, r.descripcion, r.usuario, this.formatFecha(r.fechaAct)]);
      const ws = XLSX.utils.aoa_to_sheet([headers, ...filas]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Detalle");
      XLSX.writeFile(wb, `productividad_detalle_tramite_${this.p_idtramite}.xlsx`);
    },
  },
};
</script>

<style scoped>
.nav-tabs .nav-link.active {
  background-color: #0d6efd;
  color: #fff !important;
  border-color: #0d6efd #0d6efd #fff;
}
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
thead tr:nth-child(2) th {
  cursor: default;
  font-weight: normal;
  padding: 4px 6px;
}
thead tr:nth-child(2) th input {
  font-weight: normal;
  color: #212529;
}
.progress-bar {
  transition: width 0.4s ease;
}
</style>